/**
 * 从url获取参数
 * @param variable
 * @returns {*}
 */
export function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}

/**
 * 已知value获取Object的key
 * @param object
 * @param value
 * @returns {*}
 */
export function findKey(object, value) {
    for (let key in object) {
        if (value === object[key]) {
            return key
        }
    }
    return null;
}

/**
 * 从Object移除value为空或者null的键值对
 * @param object
 * @returns {*}
 */
export function removeEmptyItem(object) {
    for (var key in object) {
        if (object[key] === '' || object[key] === null) {
            delete object[key]
        }
    }
    return object
}

/**
 * 打开外链提示
 * @param href
 */
export function openOutLink(href) {
    var tip = "您访问的链接即将离开\"韶关市公共资源交易中心\"门户网站 是否确定？";
    if (confirm(tip)) {
        window.open(href);
    }
}

function dateFtt(fmt, date) { //author: meizz
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

function getDay(d) {
    var weekday = new Array(7)
    weekday[0] = "星期天"
    weekday[1] = "星期一"
    weekday[2] = "星期二"
    weekday[3] = "星期三"
    weekday[4] = "星期四"
    weekday[5] = "星期五"
    weekday[6] = "星期六"
    return weekday[d.getDay()];
}

export function getNow() {
    var d = new Date()
    let now = dateFtt("yyyy年M月d日", d) + " " + getDay(d);
    console.log(now)
    return now;
}